import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/studio")({
  component: StudioLayout,
});

/**
 * The Studio surface — now a LAYOUT route (studio spec §4.4, workflows
 * precedent). It keeps the page chrome (the cream/dark full-height container)
 * and renders the active child via `<Outlet />`: `/studio` (the library),
 * `/studio/$appDir` (the app detail), and `/studio/new/$threadId` (the
 * gestation chat). This route owns only the shared container.
 */
function StudioLayout() {
  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-home-cream px-4 py-6 font-body text-home-ink md:px-8 md:py-8 lg:min-h-screen dark:bg-surface-dark dark:text-white">
      <Outlet />
    </div>
  );
}
